import React from 'react';
import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

const LoaderWrapper = styled.div`
  width: 100%;
  padding: 40px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #2f3fec;
  text-align: center;
`;

const Spinner = styled.div`
  width: 42px;
  height: 42px;
  border: 4px solid rgba(47, 63, 236, 0.15);
  border-top-color: #2f3fec;
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;

const LoaderMessage = styled.p`
  margin: 16px 0 0;
  font-size: 0.95rem;
  color: #1f2a44;
`;

const Loader = ({ message = 'Loading...' }) => (
  <LoaderWrapper role="status" aria-live="polite">
    <Spinner />
    {message && <LoaderMessage>{message}</LoaderMessage>}
  </LoaderWrapper>
);

export default Loader;
